import { useCallback, useEffect, useState } from "react";
import {
  CoachAdminData,
  CoachAdminFilters,
  fetchCoachesAdminData,
  initialCoachFilters
} from "../services/coachesAdminService";

export function useCoachesAdmin() {
  const [filters, setFilters] = useState<CoachAdminFilters>(initialCoachFilters);
  const [data, setData] = useState<CoachAdminData | null>(null);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const refresh = useCallback(async (nextFilters = filters) => {
    setIsLoading(true);
    setError("");

    try {
      setData(await fetchCoachesAdminData(nextFilters));
    } catch {
      setData(null);
      setError("Unable to load coaches. Check Firebase permissions and indexes.");
    } finally {
      setIsLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    void refresh(initialCoachFilters);
  }, []);

  return {
    data,
    error,
    filters,
    isLoading,
    refresh,
    setFilters
  };
}
